import { Navigate, RouteObject } from 'react-router-dom'
import { StoreFulfillmentPage } from './store-fulfillment'
import { StoreFulfillmentShip } from './ship/store-fulfillment-ship'
import { StoreFulfillmentINF } from './inf/store-fulfillment-inf'
import { StoreFulfillmentPickup } from './pickup/store-fulfillment-pickup'
import { StoreFulfillmentNdd } from './ndd'
import { StoreFulfillmentCapabilities } from './capabilities/store-fulfillment-capabilities'

export const StoreFulfillmentRoute: RouteObject = {
    path: '/store-fulfillment',
    element: <StoreFulfillmentPage />,
    children: [
        {
            index: true,
            element: <Navigate to="pickup" replace />,
        },
        {
            path: 'pickup',
            element: <StoreFulfillmentPickup />,
        },
        {
            path: 'ship',
            element: <StoreFulfillmentShip />,
        },
        {
            path: 'inf',
            element: <StoreFulfillmentINF />,
        },
        {
            path: 'ndd',
            element: <StoreFulfillmentNdd />,
        },
        {
            path: 'capabilities',
            element: <StoreFulfillmentCapabilities />,
        },
    ],
}
